import type React from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import StandardButton from 'components/buttons/StandardButton';
import { useStyles } from 'components/dialogs/avoidance/styles';
import TMXDialog from 'components/dialogs/TMXDialog';
import { type GroupParticipantInterface } from 'typedefs/avoidance';
import { participantName } from 'utils/participant';

interface ViewAvoidanceGroupDialogProps {
  groupName?: string;
  groupParticipants?: GroupParticipantInterface[];
  isOpen?: boolean;
  onClose: () => void;
}

const ViewAvoidanceGroupDialog: React.FC<React.PropsWithChildren<ViewAvoidanceGroupDialogProps>> = ({
  groupName,
  groupParticipants,
  isOpen,
  onClose,
}) => {
  const paperProps = { style: { padding: 30 } };
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <TMXDialog fullWidth open={isOpen} PaperProps={paperProps} onClose={onClose}>
      <Grid container direction="column">
        <Grid item className={classes.viewGroupsTitleContainer}>
          <Typography className={classes.viewGroupsDialogTitle} variant="h2">
            {groupName}
          </Typography>
        </Grid>
        <Grid container direction="row" spacing={2}>
          {groupParticipants?.map((participant) => (
            <Grid key={participant.id} item sm={6} xs={12}>
              <Typography>- {participantName(participant)}</Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid container direction="row" justifyContent="flex-end">
        <Grid item>
          <StandardButton onClick={onClose}>{t('Close')}</StandardButton>
        </Grid>
      </Grid>
    </TMXDialog>
  );
};

export default ViewAvoidanceGroupDialog;
